import React from 'react';

import { useToasts } from 'react-toast-notifications';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import ImageService from '@services/utils/ImageService';

import css from './ImageButton.module.scss';

type ImageButtonProps = {
    imageUploadUrl: string;
    id: string;
    editorState: any;
    modifier: any;
    hasBlackIcon?: boolean;
    onChange: (modifier1: any) => void;
};

const ImageButton = ({ imageUploadUrl, id, editorState, modifier, onChange, hasBlackIcon }: ImageButtonProps) => {
    const { t } = useTranslateLpc(['common']);
    const { addToast } = useToasts();

    const handleOnChange = (e) => {
        if (!e || !e.target || !e.target.files || !e.target.files.length) {
            return;
        }

        const file = e.target.files[0];

        const reader = new FileReader();
        reader.readAsDataURL(file);

        return (reader.onload = () => {
            return ImageService.uploadImage(reader.result, imageUploadUrl)
                .then((imageUrl) => {
                    onChange(modifier(editorState, imageUrl));
                })
                .catch((err) => {
                    addToast(t(`errors.${err.code}`), {
                        appearance: 'error',
                        autoDismiss: true,
                    });
                });
        });
    };

    return (
        <>
            <label htmlFor={id} className={css.button}>
                <input
                    type="file"
                    accept="image/jpg, image/jpeg, image/gif, image/png"
                    id={id}
                    onChange={handleOnChange}
                />
                <img
                    srcSet={`/front-static/icons/placeholder/text-editor-image${hasBlackIcon ? '-black' : ''}.svg`}
                    alt="upload_img"
                />
            </label>
        </>
    );
};

export default ImageButton;
